import React from 'react'
import './index.scss'
import Popup from '@Components/Popups/Popup'
import ConfirmationPopup from '@Components/Popups/ConfirmationPopup'

export interface ShareAmendConfirmationPopupProps {
    onClose: () => void
}
const ShareAmendConfirmationPopup = ({ onClose }: ShareAmendConfirmationPopupProps) => (
    <div className="share-confirmation-popup">
        <Popup onClose={onClose}>
            <ConfirmationPopup
                title="Your shares on this work have been amended."
                onConfirm={onClose}
                confirmButtonText="Done"
            >
                Your shares on this work will be updated in your catalog to reflect the new share percentage within 1-3
                weeks.
            </ConfirmationPopup>
        </Popup>
    </div>
)

export default ShareAmendConfirmationPopup
